import React, { Component } from 'react';
import Incrementor from './components/Incrementor.js'
import _ from 'underscore'
import moment from 'moment'
// import { providerContextTypes } from 'react-stripe-elements/lib/components/Provider';

class Lunch extends Component {

  componentDidMount(){
    var order = this.props.order;
    order.items = [];//order.items.filter(x=> x.type !== 'coffee');
    order.prevItems = [];
    order.type = 'lunch';
    this.props.updateOrder(order, this.updateDay.bind(this));
  }

  getCategories(){
    return _.uniq(this.props.foods.map(food => food.category))
  }

  findOrderItem(id){
    return this.props.order.items.find(x=>x.id === id);
  }

  findInvItem(id){
    return this.props.foods.find(x=>x.id === id);
  }

  getOrderItemQty(id){
    var item = this.findOrderItem(id);
    if(!item) return 0;
    return item.quantity;
  }

  getOrderItemTime(id){
    var item = this.findOrderItem(id);
    if(!item) return null;
    return item.time;
  }

  updateOrderQty(id, dir){
    var item = this.findOrderItem(id),
      order = this.props.order;
    if(!item){
      item = this.findInvItem(id);
      item = {
        id: item.id,
        name: item.name,
        price: item.price,
        quantity: 0,
        time: 'Lunch',
        healthy: item.healthy,
        person: this.props.order.customer
      };
      order.items.push(item);
    }
    if(item.quantity < 1 && dir < 1)
      return;
    item.quantity += dir;

    order.items = order.items.filter(x=>x.quantity > 0)

    this.props.updateOrder(order);
  }

  handleTimeChange(e){
    var item = this.findOrderItem(parseInt(e.currentTarget.dataset.food, 10)),
      order = this.props.order;
    item.time = e.currentTarget.value;
    setTimeout(()=>this.props.updateOrder(order));
  }

  getFoods(cat){
    return this.props.foods.filter(food=>
      !this.props.order.customer ||
      !food.schools.length ||
      food.schools.indexOf(this.props.order.customer.school.id) > -1
    ).filter(food => !cat || food.category === cat)
    .map((food, i)=>([
      <tr key={i}>
        <td>{food.name}</td>
        <td>${this.toCurrency(food.price)}</td>
        <td className="hidden-xs">{food.healthy}</td>
        <td>
          <Incrementor value={this.getOrderItemQty(food.id)}
          update={this.updateOrderQty.bind(this, food.id)} />
        </td>
      </tr>,
      <tr className={this.props.order.customer.school.morningTea ? '' : 'hidden'}
        key={i + 0.1}>
        { this.getOrderItemQty(food.id) ? <td colSpan="4">

            <label className="radio-inline"
              style={{marginLeft: '10px', float:'right'}}>
              <input type="radio"
                name={"time"+food.id}
                id="inlineRadio2"
                data-food={food.id}
                autoComplete="off"
                onChange={this.handleTimeChange.bind(this)}
                checked={this.getOrderItemTime(food.id) === 'Lunch'}
                value="Lunch"/> Lunch
            </label>

            <label className="radio-inline"
              style={{marginLeft: '10px', float:'right'}}>
              <input type="radio"
                name={"time"+food.id}
                id="inlineRadio1"
                data-food={food.id}
                autoComplete="off"
                onChange={this.handleTimeChange.bind(this)}
                checked={this.getOrderItemTime(food.id) === 'Morning Tea'}
                value="Morning Tea"/> Morning Tea
            </label>
        </td> : null}
      </tr>
    ]))
  }

  getTotal(){
    var order = this.props.order
    return order.items.concat(order.prevItems || []).reduce((x, y)=>x+ y.price*y.quantity, 0)
  }

  handleNext(e){
    var order = this.props.order
    if(order.items.length + order.prevItems.length === 0)
      e.preventDefault();
  }

  handleOrderChange(e){
    var val = e.target.value,
      order = this.props.order
    if(e.target.name === 'customer'){
      val = this.props.people.find(student=>(''+student.id) === e.target.value);
      _.each(order.items, item => item.person = val)
    }
    else if(e.target.name === 'date')
      val = this.props.days.find(day=>day.date === e.target.value);
    order[e.target.name] = val;
    this.props.updateOrder(order, this.updateDay.bind(this));
  }

  updateDay(){
    var select = document.getElementById('orderdate')
    if(select.value !== this.props.order.date.date){
      this.props.order.date = {
        date: moment(select.value),
        name: moment(select.value).format('dddd')
      }
      this.props.updateOrder(this.props.order)
    }
  }

  toCurrency(num){
    return (Math.ceil(num * 100) / 100).toFixed(2)
  }

  shouldShowDay(day){
    // console.log(day)
    var schDays = this.props.order.customer.school.days
    if(!schDays)
      return true;
    if(schDays.indexOf(day.name.toLowerCase()) > -1)
      return true;
    if(day.name==='Today'){
      var today = moment().format('dddd').toLowerCase()
      return schDays.indexOf(today) > -1
    }
  }

  addOrder(e){
    e.preventDefault()
    var order = this.props.order
    // _.each(order.items, item => item.person = this.props.order.customer)
    order.prevItems = order.prevItems ? order.prevItems.concat(order.items) : []
    order.items = []
    this.props.updateOrder(order)
  }

  existingOrderPeople(){
    var order = this.props.order
    var people = order.prevItems.map(item=>item.person.name)
    if(order.items.length)
      people.push(order.customer.name)
    return _.uniq(people)
  }

  render() {
    var order = this.props.order,
      nextEnabled = order.items.length || (order.prevItems && order.prevItems.length)
    return (
      <div className="">
        <h1>New Food Order</h1>

        <form className="form-horizontal">

          <div className="form-group">
            <label htmlFor="orderdate" className="col-sm-2 control-label">Day</label>
            <div className="col-sm-10">
              <select className="form-control"
                id="orderdate"
                value={order.date.date}
                onChange={this.handleOrderChange.bind(this)} name="date">
                {this.props.days.map((day, i)=>
                  this.shouldShowDay(day) ?
                    <option value={day.date} key={i}>{day.name}</option> : null
                )}
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="orderfor" className="col-sm-2 control-label">Order For</label>
            <div className="col-sm-10">
              { order.customer ? (
                <select className="form-control"
                  id="orderfor"
                  value={order.customer.id}
                  onChange={this.handleOrderChange.bind(this)}
                  name="customer">

                  {this.props.people.map((person, i)=>
                    <option value={person.id} key={i}>{person.name}</option>
                  )}

                </select>
              ) : null}
              <div className="text-right">
                <a href="#/people">Add/Edit People</a>
              </div>
            </div>
          </div>
        </form>


        <div className="panel-group" id="accordion" role="tablist" aria-multiselectable="true">

          { this.getCategories().map((cat, i) => (
            <div key={i} className="panel panel-default">
              <a className="panel-heading"
                style={{display: 'block'}} role="tab"
                id={"heading"+i}
                data-toggle="collapse"
                data-parent="#accordion"
                href={"#collapse"+i}
                aria-expanded="false"
                aria-controls={"collapse"+i}>

                <h4 className="panel-title">
                    {cat}
                </h4>
              </a>

              <div id={"collapse"+i} className="panel-collapse collapse" role="tabpanel" aria-labelledby={"heading"+i}>
                <div className="panel-body">

                  <table className="table">
                    <thead>
                      <tr>
                        <th>Item</th>
                        <th>Price</th>
                        <th className="hidden-xs">Healthy</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      { this.getFoods(cat) }
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          ))}

        </div>


        <div className="text-center">
          <h2>Order Total ${this.toCurrency(this.getTotal())}</h2>
        </div>

        <textarea className="form-control"
          placeholder="Order Notes" value={order.notes}
          onChange={this.handleOrderChange.bind(this)} name="notes"></textarea>
        <br />

        { order.prevItems && order.prevItems.length ? (
            <div>
              <ul className="float-right">
                { this.existingOrderPeople().map(item => <li key={item}>{item}</li>)}
              </ul>
              <p className="float-right">Orders for:</p>
            </div>
          ) : null }

        <div className="row" style={{marginBottom: '10px'}}>
          <div className="col-xs-offset-6 col-xs-6">
            <a href=""
              onClick={this.addOrder.bind(this)}
              className="btn btn-default btn-lg btn-block">Add another order</a>
          </div>

        </div>

        <div className="row">
          
          <div className="col-xs-6">
            <a href="#/dashboard"
              className="btn btn-default btn-lg btn-block">Back</a>
          </div>

          <div className="col-xs-6">
            <a href="#/confirm"
              className="btn btn-primary btn-lg btn-block"
              onClick={this.handleNext.bind(this)}
              disabled={!nextEnabled}>Next</a>
          </div>
        </div>

      </div>
    );
  }
}

export default Lunch;



// WEBPACK FOOTER //
// ./src/pages/Lunch.js